"use strict";
/*
 * Copyright (C) 2019-2021 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJsonDataProvider = exports.AuthenticationMethod = exports.APIFormat = void 0;
var harp_vectortile_datasource_1 = require("@here/harp-vectortile-datasource");
Object.defineProperty(exports, "APIFormat", { enumerable: true, get: function () { return harp_vectortile_datasource_1.APIFormat; } });
Object.defineProperty(exports, "AuthenticationMethod", { enumerable: true, get: function () { return harp_vectortile_datasource_1.AuthenticationMethod; } });
Object.defineProperty(exports, "GeoJsonDataProvider", { enumerable: true, get: function () { return harp_vectortile_datasource_1.GeoJsonDataProvider; } });
__exportStar(require("./lib/OmvDataSource"), exports);
//# sourceMappingURL=index.js.map